import { createGlobalInstance, getGlobalInstance } from '@authy/lib-client/utils/state'
import { initWebAppState } from '@authy/lib-web/appState'

import { AdminAppState } from './AdminAppState'

export let adminAppState: AdminAppState = getGlobalInstance('adminAppState')

export const initAdminAppState = (state: AdminAppState) => {
    initWebAppState(state)
    adminAppState = createGlobalInstance('adminAppState', () => state)
}

export * from './AdminAppState'
export * from './types'
